import { LocalStorageManager } from './db'

export const localStorageClient = new LocalStorageManager()
